module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/datagrid/datagrid-header/datagrid-header.component.html
// module id = ./libs/atenea-cms/src/datagrid/datagrid-header/datagrid-header.component.html
// module chunks = main